import { ProcessoAPI } from "@/api/processo.api";
import { AxiosObservable } from "axios-observable/dist/axios-observable.interface";
import { Processo } from "@/models/processo";

const processoApi = new ProcessoAPI();

const show = (processoId: number): AxiosObservable<Processo> => {
  return processoApi.show(processoId);
};

export default { show };
